import { useManageRolesStore } from "PFApp/stores/manage_roles";
import { RouterPrompt } from "PFComponents/router_prompt/router_prompt";

type PendingEditsRouterPromptProps = {
  onOK: () => Promise<boolean>;
};

export const PendingEditsRouterPrompt = ({ onOK }: PendingEditsRouterPromptProps) => {
  const hasPendingEdits = useManageRolesStore((state) => Object.keys(state.pendingEdits).length > 0);

  return <RouterPrompt when={hasPendingEdits} onOK={onOK} />;
};
